import $ from 'jquery';
import connectFilterNotifications from 'legacy/javascripts/notification.js';

$(function () {
  var $options = $('.js-alert-filter-options');
  var $form = $('.js-filter-form');
  if (
    !$options.length ||
    !$form.length ||
    connectFilterNotifications.emailNotificationsOn()
  ) {
    return;
  }

  var filtersSet = function () {
    $options.find('.js-update-alert-filters-button').removeClass('hidden');
    $options.find('.js-set-alert-filters-button').addClass('hidden');
  };

  var filtersUnset = function () {
    $options.find('.js-update-alert-filters-button').addClass('hidden');
    $options.find('.js-set-alert-filters-button').removeClass('hidden');
  };

  var alertNotificationsOff = function () {
    $('.js-notifications-off-modal').modal('show');
  };

  connectFilterNotifications.isOn() ? filtersSet() : filtersUnset();

  $options.find('.js-save-alert-filters').click(function () {
    if (
      $(this).is('.js-set-alert-filters-button') &&
      connectFilterNotifications.isIE()
    ) {
      var message = $('.js-alert-filter-options').data().ieMessage;
      if (!window.confirm(message)) {
        return;
      }
    }
    connectFilterNotifications.setFilters(
      $form,
      filtersSet,
      alertNotificationsOff
    );
  });

  $options.find('.js-clear-alert-filters').click(function () {
    connectFilterNotifications.clear();
    filtersUnset();
  });
});
